import React from "react";
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ModalContent = ({ open, onClose, title, children, width = "sm", disableBackdropClose = false, showCloseIcon = false }) => {
  const handleClose = (event, reason) => {
    if (disableBackdropClose && reason === "backdropClick") return;
    onClose(event, reason);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth={width} fullWidth>
      {title ? (
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" sx={{ visibility: "hidden" }}>
            S
          </Typography>
          <Typography variant="h6">{title}</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
      ) : showCloseIcon ? (
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            p: 1,
          }}
        >
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
      ) : null}
      <DialogContent
        sx={{
          mt: 2,
          overflow: "auto",
          // "&::-webkit-scrollbar": {
          //   display: "none",
          // },
          // scrollbarWidth: "none",
        }}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default ModalContent;
